(function () {
  if (window.__avviRechargePriceSync) return;
  window.__avviRechargePriceSync = true;

  const previousReady = window.RechargeSubscriptionWidgetReady;

  window.RechargeSubscriptionWidgetReady = function (widget) {
    if (typeof previousReady === 'function') previousReady.call(this, widget);

    let variantId = widget.variantId;
    let sellingPlanId = widget.sellingPlanId;

    function updatePrice() {
      const prices = window.SubscriptionWidgetConfig?.formattedPrices?.[variantId];
      if (!prices) return;

      const plan = prices.sellingPlans?.[sellingPlanId];
      const price = sellingPlanId
        ? plan?.quantityUpsell?.totalDiscountedPrice || plan?.price
        : prices.unit;
      if (!price) return;

      document.querySelectorAll('product-form-component form').forEach((form) => {
        if (form.querySelector('[name="id"]')?.value !== String(variantId)) return;
        form.querySelectorAll('.add-btn-price').forEach((element) => {
          element.textContent = price;
        });
      });
    }

    widget.events.onSellingPlanChange((id) => {
      sellingPlanId = id;
      queueMicrotask(updatePrice);
    });
    widget.events.onVariantChange((id) => {
      variantId = id;
      queueMicrotask(updatePrice);
    });
    queueMicrotask(updatePrice);
  };
})();
